import { computed, onBeforeUnmount, onMounted } from 'vue';
import router from '@/router';

const getHashPath = () => window.location.hash.replace(/^#/, '') || '/';

export const useVueRouteState = () => {
    const isVueRoute = computed(() => router.currentRoute.value.path.startsWith('/v/'));

    const syncVueRouter = () => {
        const path = getHashPath();
        if (router.currentRoute.value.fullPath !== path) {
            void router.replace(path);
        }
    };

    onMounted(() => {
        syncVueRouter();
        window.addEventListener('hashchange', syncVueRouter);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('hashchange', syncVueRouter);
    });

    return {
        isVueRoute,
    };
};
